export const ONBOARD_VENDOR_INFO_ACTION = "ONBOARD_VENDOR_INFO_ACTION";
export const ONBOARD_VENDOR_INFO_LOADING = "ONBOARD_VENDOR_INFO_LOADING";
export const ONBOARD_VENDOR_INFO_SUCCESS = "ONBOARD_VENDOR_INFO_SUCCESS";
export const ONBOARD_VENDOR_INFO_ERROR = "ONBOARD_VENDOR_INFO_ERROR";

export const ONBOARD_VENDOR_VERIFY_ACTION = "ONBOARD_VENDOR_VERIFY_ACTION";
export const ONBOARD_VENDOR_VERIFY_LOADING = "ONBOARD_VENDOR_VERIFY_LOADING";
export const ONBOARD_VENDOR_VERIFY_SUCCESS = "ONBOARD_VENDOR_VERIFY_SUCCESS";
export const ONBOARD_VENDOR_VERIFY_ERROR = "ONBOARD_VENDOR_VERIFY_ERROR";
